import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { jacksonvilleNcConfig } from "./data";

export default function JacksonvilleNcPage() {
  return <CityPageTemplate config={jacksonvilleNcConfig} />;
}